import Accordion from './modules/accordion';
import smoothscroll from 'smoothscroll-polyfill';

(function() {
  // kick off the polyfill!
  smoothscroll.polyfill();

  window.addEventListener('load', function () {
    checkUrlForHash();
  });


  let faq1 = new Accordion({
    accordionContainerId: 'js-faq',
    accordionButtonClass: 'js-faq-button',
    accordionPanelClass: 'js-faq-panel',
    useOpenCloseBtns: true,
    openBtnClass: 'js-open-all',
    closeBtnClass: 'js-close-all' 
  });

  //hide all faq categories but the first one
  let faqCat = document.getElementsByClassName('js-faq-cat');

  for (let i = 0; i < faqCat.length; i++) {
    if ( i === 0 ) {
      faqCat[i].classList.add('selected');
    } else {
      faqCat[i].classList.add('hidden');
    }
  }

  //add event listener to faq nav
  let faqNav = document.getElementsByClassName('js-nav-link');

  for (let i = 0; i < faqNav.length; i++) {
    faqNav[i].addEventListener('click', function(e) {

      let link = this.getAttribute('href');
      let faqCatSelected = document.getElementsByClassName('js-faq-cat selected');

      faqCatSelected[0].classList.add('hidden');
      faqCatSelected[0].classList.remove('selected');

      let selectedBtns = document.getElementById('js-nav-list').getElementsByClassName('active');

      for (let i = 0; i < selectedBtns.length; i++) {
        selectedBtns[i].classList.remove('active');
      }

      this.parentElement.classList.add('active');

      let el = document.getElementById(link.substr(1));
      
      el.classList.remove('hidden');
      el.classList.add('selected');

      scrollTo(el);

    });
    
  }

  const faqFilterNav = document.getElementById('js-nav');
  const faqFilterButton = document.getElementById('js-filter-btn');
  const faqFilterCloseButton = document.getElementById('js-close-btn');

  if (faqFilterNav) {
    faqFilterNav.classList.add('hidden');

    faqFilterButton.addEventListener('click', function(e) {
      e.preventDefault();

      toggleFilter();

    });

    faqFilterCloseButton.addEventListener('click', function(e) {
      e.preventDefault();

      toggleFilter();

    });
  }
    
  function toggleFilter() {
    let btnContainer = document.getElementById('js-filter-btn-bkgd');
    let btnText = document.getElementById('js-filter-btn-text');
    let nav = document.getElementById('js-nav');

    if (btnContainer.classList.contains('open')) {
      btnContainer.classList.remove('open');
      btnText.textContent = 'Open Filter';
      nav.classList.add('hidden');
    } else {
      btnContainer.classList.add('open');
      btnText.textContent = 'Close Filter';
      nav.classList.remove('hidden');
    }

  }

  function checkUrlForHash() {
    let hash = window.location.hash;

    if (hash.length) {
        let el = document.querySelector('a[href="' + hash + '"]');
        if (el) {
            el.click();
        }
    }
  }

  function scrollTo(el) {
    el.scrollIntoView({
      behavior: 'smooth'
    });
    el.focus({preventScroll:true});
  }

})();
